namespace AgerLMS.LMS {
    export interface CargoRow {
        Id?: number;
        CargoName?: string;
        Count15?: number;
        Count610?: number;
        Count1115?: number;
        Count1620?: number;
        Count2125?: number;
        Count2630?: number;
        After30?: number;
        FirmCode?: string;
        TaxNumber?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace CargoRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CargoName';
        export const localTextPrefix = 'LMS.Cargo';
        export const lookupKey = 'LMS.Cargos';

        export function getLookup(): Q.Lookup<CargoRow> {
            return Q.getLookup<CargoRow>('LMS.Cargos');
        }
        export const deletePermission = 'LMS:Cargo:Modify';
        export const insertPermission = 'LMS:Cargo:Modify';
        export const readPermission = 'LMS:Cargo:Read';
        export const updatePermission = 'LMS:Cargo:Modify';

        export declare const enum Fields {
            Id = "Id",
            CargoName = "CargoName",
            Count15 = "Count15",
            Count610 = "Count610",
            Count1115 = "Count1115",
            Count1620 = "Count1620",
            Count2125 = "Count2125",
            Count2630 = "Count2630",
            After30 = "After30",
            FirmCode = "FirmCode",
            TaxNumber = "TaxNumber",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
